<div 
  class="so-switch-container"
  [class.expanded]="expanded()"
  [class.label-on-left]="labelOnLeft()"
  [attr.title]="tooltip() || null">

  <!-- Legacy left label -->
  @if (showLeftLabel()) {
    <span 
      class="so-switch-label legacy-label"
      [class]="leftLabelClass()"
      [ngStyle]="labelLeftStyle()"
      [style]="customStyleFont()">
      {{ labelLeft() }}
    </span>
  }

  <!-- Modern label (left position) -->
  @if (!labels() && labelOnLeft() && (label() || subtitle())) {
    <div class="so-switch-label-wrapper">
      @if (label()) {
        <span class="so-switch-label-text" [class.disabled]="effectiveDisabled()">
          {{ label() }}
        </span>
      }
      @if (subtitle()) {
        <span class="so-switch-subtitle">{{ subtitle() }}</span>
      }
    </div>
  }

  <!-- Switch track -->
  <div 
    class="so-switch-track"
    [class.disabled]="effectiveDisabled()"
    [style.width]="switchWidth()"
    [style.height]="switchHeight()"
    [style.border-radius]="borderRadius()"
    [style.background-color]="trackColor()"
    [style.box-shadow]="boxShadow()"
    [attr.role]="'switch'"
    [attr.aria-checked]="internalValue()"
    [attr.aria-disabled]="effectiveDisabled()"
    [attr.tabindex]="effectiveDisabled() ? -1 : 0"
    (click)="onToggle()"
    (keydown)="onKeydown($event)">
    
    <!-- Thumb -->
    <div 
      class="so-switch-thumb"
      [style.width.px]="thumbSize()"
      [style.height.px]="thumbSize()"
      [style.background-color]="thumbColor()"
      [style.left.px]="thumbPosition()">
    </div>
  </div>

  <!-- Modern label (right position) -->
  @if (!labels() && !labelOnLeft() && (label() || subtitle())) {
    <div class="so-switch-label-wrapper">
      @if (label()) {
        <span class="so-switch-label-text" [class.disabled]="effectiveDisabled()">
          {{ label() }}
        </span>
      }
      @if (subtitle()) {
        <span class="so-switch-subtitle">{{ subtitle() }}</span>
      }
    </div>
  }

  <!-- Legacy right label -->
  @if (showRightLabel()) {
    <span 
      class="so-switch-label legacy-label"
      [class]="rightLabelClass()"
      [ngStyle]="labelRightStyle()"
      [style]="customStyleFont()">
      {{ labelRight() }}
    </span>
  }
</div>
